export default __webpack_public_path__ + "static/media/hero@3x.8d46ee54.png";